import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function HeroVideoBg() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [muted, setMuted] = useState(true);
  const [src] = useState(() => (window.matchMedia("(max-width: 767px)").matches ? "/hero-bg-mobile.mp4" : "/hero-bg-v2.mp4"));

  useEffect(() => {
    // Always start muted: audio only when the visitor taps an audio button
    const v = ref.current;
    v.muted = true;
    v.play().catch(() => {});
  }, []);

  const toggleSound = (e) => {
    e.stopPropagation();
    const v = ref.current;
    v.muted = !muted;
    setMuted(!muted);
    if (muted) v.play().catch(() => {});
  };

  return (
    <>
      <div aria-hidden data-testid="hero-video-frame" className="pointer-events-none absolute inset-x-0 top-0 aspect-video overflow-hidden bg-black md:aspect-auto md:h-[100svh]" style={{ zIndex: 0 }}>
        <img src="/hero-poster-v2.jpg" alt="" draggable={false} className="absolute inset-0 h-full w-full object-contain md:object-cover" />
        <video
          ref={ref}
          onPlaying={() => setVisible(true)}
          data-testid="hero-bg-video"
          className="hero-bg-video relative h-full w-full object-contain md:object-cover"
          style={{ objectPosition: "center center", opacity: visible ? 1 : 0, transition: "opacity 0.4s ease" }}
          src={src}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          tabIndex={-1}
          disablePictureInPicture
          disableRemotePlayback
          controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
        />
        <div className="absolute inset-0 md:hidden" style={{ background: "linear-gradient(180deg, rgba(0,3,15,0.1) 0%, rgba(0,3,15,0.1) 75%, rgba(0,3,15,0.85) 100%)" }} />
        <div className="absolute inset-0 hidden md:block" style={{ background: "linear-gradient(180deg, rgba(0,3,15,0.2) 0%, rgba(0,3,15,0.3) 75%, rgba(0,3,15,1) 100%)" }} />
      </div>
      <button
        type="button"
        onClick={toggleSound}
        data-testid="hero-audio-desktop-toggle"
        aria-label={muted ? "Attiva l'audio" : "Disattiva l'audio"}
        className="hero-audio-desk absolute right-6 hidden md:flex items-center justify-center rounded-full transition-opacity duration-200 opacity-60 hover:opacity-100"
        style={{ zIndex: 2, width: 36, height: 36, background: "rgba(0,0,0,0.45)", border: "1px solid rgba(255,255,255,0.25)", color: "#fff", backdropFilter: "blur(6px)" }}
      >
        {muted ? <VolumeX size={15} /> : <Volume2 size={15} />}
      </button>
      {muted && (
        <button
          type="button"
          onClick={toggleSound}
          onTouchEnd={(e) => e.stopPropagation()}
          data-testid="hero-audio-toggle"
          aria-label="Attiva l'audio"
          className="hero-audio-btn absolute left-1/2 flex items-center gap-3 rounded-full transition-opacity duration-200 opacity-90 hover:opacity-100"
          style={{ zIndex: 2, transform: "translate(-50%, -50%)", padding: "14px 24px", background: "rgba(0,0,0,0.38)", border: "1px solid rgba(255,255,255,0.3)", color: "#fff", backdropFilter: "blur(8px)", fontWeight: 600, fontSize: "0.95rem", whiteSpace: "nowrap" }}
        >
          <VolumeX size={22} /> Attiva l'audio
        </button>
      )}
    </>
  );
}
